import React from "react";
import stl from "./WarrantyAndDealerSection.module.css";

const WarrantyAndDealerSection = ({ warranty_card }) => {
  return (
    <div className={stl.container}>
      {warranty_card?.warranty && (
        <div>
          <img width={"24px"} src={warranty_card?.warranty?.icon} alt="icon" />
          <div>
            <span>{warranty_card?.warranty?.label}:</span>
            <strong>{warranty_card?.warranty?.name}</strong>
          </div>
        </div>
      )}
      {warranty_card?.wakeel && (
        <div>
          <img width={"24px"} src={warranty_card?.wakeel?.icon} alt="icon" />
          <div>
            <span>{warranty_card?.wakeel?.label}:</span>
            <strong>{warranty_card?.wakeel?.name}</strong>
          </div>
        </div>
      )}
    </div>
  );
};

export default WarrantyAndDealerSection;
